// extracted by mini-css-extract-plugin
module.exports = {"container":"defaultText_container__1X53Y","paragraph":"defaultText_paragraph__3kd6Z"};